/* TrackDNA — Category Hub. Task 20.
 *
 * The ONLY job: collapse the category disclosures below the desktop
 * breakpoint. No CSS can set a <details> open state at a media query —
 * `details::details-content` is Chrome 131 / Safari 18.4 / Firefox 139 and
 * fails CLOSED on older engines, which would leave the content unreachable.
 * That is an accessibility regression, not a graceful degradation.
 *
 * So `open` ships in the HTML and this script only ever REMOVES it. A script
 * that fails to run leaves a long, complete, fully readable page — never a
 * hidden one.
 *
 * Everything else on this page is native and needs no JavaScript: the
 * accordion is <details>/<summary> (keyboard and screen-reader behaviour
 * included), the rail is in-page anchors, the sticky band is position:sticky,
 * and the directory is CSS multi-column.
 *
 * No resize listener, deliberately: re-collapsing on rotation would fight a
 * shopper who has just opened a category, and desktop CSS leaves the summary
 * clickable, so resizing up past 1024 can never trap content shut.
 */
(function () {
  'use strict';

  function boot(root) {
    if (window.matchMedia('(min-width: 1024px)').matches) return;
    var open = (root || document).querySelectorAll('[data-category-hub] details[open]');
    for (var i = 0; i < open.length; i++) open[i].open = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // The theme editor re-renders the section on every setting change. Scoped to
  // event.target so re-rendering this section does not touch anything else.
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
